module.exports = __webpack_public_path__ + "img/form-3.f0abf0ea.png";